import { DeliveryNotificationsComponent } from './../delivery-notifications.component';
import { DeliveryNotificationsService } from './../../../services/delivery-notifications/delivery-notifications.service';
import { CatalogsService } from './../../../services/catalogs/catalogs.service';
import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Validators, FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { ToasterModule, ToasterService, Toast, ToasterConfig } from 'angular5-toaster';
import { StorageService } from '../../../services/storage.service';
import { User } from '../../../models/user';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-upload-position',
  templateUrl: './upload-position.component.html',
  styleUrls: ['./upload-position.component.scss'],
  providers: [DeliveryNotificationsService, CatalogsService]
})
export class UploadPositionComponent implements OnInit {
  @ViewChild('myTable') table: any;
  @Input() messages: any = {
    emptyMessage: '',
    totalMessage: '',
    selectedMessage: ''
  };
  public user: User;
  closeResult: string;
  rows: any[] = [];
  entradasMercanciaSeleccionadas = [];
  importe;
  monedaSeleccionada;
  paisUsuario;
  modalRespuesta;
  respuesta;
  titulo;
  mensaje;
  busy: boolean = false;
  toastErrorEnviarFacturas;
  toastAsn;
  toastErrorExcel;
  public toasterconfig: ToasterConfig =
    new ToasterConfig({ timeout: 500 });

  constructor(
    private translate: TranslateService,
    private storageService: StorageService,
    private deliveryNotifications: DeliveryNotificationsService,
    private catalogos: CatalogsService,
    public activeModal: NgbActiveModal,
    private toasterService: ToasterService,
    private modalService: NgbModal
  ) {
    this.translate.get('texto.noHayInformacionLabel').subscribe(
      text => {
        this.messages.emptyMessage = text;
      });

    this.translate.get('texto.totalLabel').subscribe(
      text => {
        this.messages.totalMessage = text;
      });

    this.translate.get('texto.seleccionadoLabel').subscribe(
      text => {
        this.messages.selectedMessage = text;
      });

    this.translate.get('texto.toastErrorEnviarFacturas').subscribe(
      text => {
        this.toastErrorEnviarFacturas = text;
      });

    this.translate.get('texto.toastASNGenerado').subscribe(
      text => {
        this.toastAsn = text;
      });

    this.translate.get('texto.toastErrorXML').subscribe(
      text => {
        this.toastErrorExcel = text;
      });
  }

  ngOnInit() {
    this.noBack();
    this.user = this.storageService.getCurrentUser();
    this.paisUsuario = this.user.pais;
    this.rows = this.entradasMercanciaSeleccionadas;
    this.importeTotal();
  }

  noBack() {
    history.pushState(null, null, location.href);
    window.onpopstate = function () {
      history.go(1);
    };
  }

  importeTotal() {
    let importeCount = 0;
    let importeTotal = 0;
    for (let i = 0; i < this.entradasMercanciaSeleccionadas.length; i++) {
      this.monedaSeleccionada = this.entradasMercanciaSeleccionadas[0].clave_moneda;
      importeCount = this.entradasMercanciaSeleccionadas[i].total;
      importeTotal = importeTotal + importeCount;
    }

    this.importe = importeTotal;
  }

  closeModal() {
    this.activeModal.close('cancelar');
  }

  enviarFacturas(mensajeRes, file1: File) {
    this.busy = true;

    if (file1) {
      const formData: FormData = new FormData();
      formData.append('archivoxml', file1);

      this.busy = true;
      this.deliveryNotifications.envioXML(formData).subscribe(
        data => {
          this.busy = false;
          this.respuesta = data.result;
          this.mensaje = this.respuesta.message;
          if (this.respuesta.status === 'S') {
            this.titulo = this.toastAsn;
          } else {
            this.titulo = this.toastErrorEnviarFacturas;
          }
          this.activeModal.close();
          this.busy = false;
          this.openMensajeRespuesta(mensajeRes);

        },
        error => {
          this.busy = false;
          console.error(error);
        }
      );
    } else {
      this.busy = false;
      this.toasterService.pop('error', 'Error', this.toastErrorExcel);
    }
  }


  openMensajeRespuesta(mensajeRes) {
    this.modalRespuesta = this.modalService.open(mensajeRes, { centered: true, keyboard: false, backdrop: 'static' });
    this.modalRespuesta.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

}






// WEBPACK FOOTER //
// ./src/app/pages/delivery-notifications/upload-position/upload-position.component.ts